import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { CQMSConfigurationService } from 'src/app/Services/CQMSConfiguration/cqmsconfiguration.service';

@Component({
  selector: 'app-cqms-merge-patient',
  templateUrl: './cqms-merge-patient.component.html',
  styleUrls: ['./cqms-merge-patient.component.css']
})

export class CqmsMergePatientComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<CqmsMergePatientComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private cqmsConfigurationService: CQMSConfigurationService, private toastr: ToastrService) {
    var data = data;
  }


  ngOnInit() {


  }
  patdetailslist = '';
  ChangePatientMergedetails(event) {
    this.patdetailslist = event.target.value;

  }
  Patientids: any = '';
  mainpatientid: any = '';
  SubmitMergeData() {
    if (this.patdetailslist != "" && this.patdetailslist != null)
      this.mainpatientid = this.patdetailslist;
    else {
      this.toastr.error('select the merge with patients');
      return;
    }

    this.data.forEach(element => {
      this.Patientids += element.patId + ',';
    });
    this.Patientids = this.Patientids.substring(0, this.Patientids.length - 1);

    this.cqmsConfigurationService.UpdateMergePatientIds(this.Patientids, this.mainpatientid).subscribe(data => {
      this.data = data;
      this.toastr.success(data);
      this.dialogRef.close(true);

    });

  }
  onNoClick(): void {
    this.dialogRef.close();
  }

}
